import { render, staticRenderFns } from "./DiscountsOverview.vue?vue&type=template&id=64750848"
import script from "./DiscountsOverview.vue?vue&type=script&lang=js"
export * from "./DiscountsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports